"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SOCIAL_SECURITY_NUMBER = void 0;
var entities_1 = require("@common/entities");
var DONT_HAVE_FIELD_NAME_1 = require("./DONT_HAVE_FIELD_NAME");
exports.SOCIAL_SECURITY_NUMBER = {
    name: 'social_security_number',
    label: 'Social Security Number',
    customType: entities_1.IDTypes.SocialSecurityNumber,
    elementType: entities_1.SectionElementType.Block,
    fields: [
        {
            customType: entities_1.FieldType.SSN,
            enabled: true,
            label: 'Social Security Number',
            name: entities_1.IdTypeFields.value.name,
            required: false,
            sequence: 1,
            type: entities_1.FieldType.SSN,
        },
        {
            customType: entities_1.FieldType.Checkbox,
            enabled: false,
            label: "I don't have a Social Security Number.",
            name: DONT_HAVE_FIELD_NAME_1.ID_TYPE_DONT_HAVE_FIELD_NAME_MAPPING[entities_1.IDTypes.SocialSecurityNumber],
            required: false,
            sequence: 5,
            type: entities_1.FieldType.Checkbox,
        },
    ],
};
